import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import type { SurveyId, SurveyTemplate } from '../../domain/SurveyTemplates/SurveyTemplate';
import { SurveyTemplatesListItem } from './SurveyTemplatesListItem/SurveyTemplatesListItem';

const Container = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: ${tokens.spacer.x3};
`;

const EmbeddableWidgetContainer = styled.div`
  min-width: 100%;
  z-index: 1;
`;

export interface SurveyTemplatesListProps {
  onSelected: (surveyId: SurveyId) => void;
  templates: SurveyTemplate[];
}

export const SurveyTemplatesList = ({
  onSelected,
  templates,
}: SurveyTemplatesListProps): JSX.Element => {
  // split the list of templates to show an embeddable widget in the middle
  const firstSixTemplates = templates.slice(0, 6);
  const restOfTemplates = templates.slice(6);
  return (
    <Container>
      {firstSixTemplates.map((template, index) => (
        <SurveyTemplatesListItem
          testIndex={index}
          key={template.entry_id}
          onClick={() => {
            onSelected(template.survey_id);
          }}
          title={template.title}
          description={template.intro_text}
          imageUrl={template.hero_image}
        />
      ))}
      {templates.length > 0 && <EmbeddableWidgetContainer id="embeddable-survey-templates" />}
      {restOfTemplates.map((template, index) => (
        <SurveyTemplatesListItem
          testIndex={index}
          key={template.entry_id}
          onClick={() => {
            onSelected(template.survey_id);
          }}
          title={template.title}
          description={template.intro_text}
          imageUrl={template.hero_image}
        />
      ))}
    </Container>
  );
};
